import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  companies: null,
  companyCount: 0,
  totalCompanies: null,
};

const companyListingSlice = createSlice({
  name: "companyListing",
  initialState,
  reducers: {
    fetchCompanies(state, action) {
      state.loading = true;
    },
    fetchCompaniesSuccess(state, action) {
      state.companies = action.payload.data.document;
      state.companyCount = action.payload.count;
      state.loading = false;
    },
    fetchCompaniesFailure(state, action) {
      state.loading = false;
    },
    fetchTotalCompanies(state, action) {
      state.loading = true;
    },
    fetchTotalCompaniesSuccess(state, action) {
      state.totalCompanies = action.payload.data.document;
      state.loading = false;
    },
    fetchTotalCompaniesFailure(state, action) {
      state.loading = false;
    },
  },
});

export const { actions, reducer, name: sliceKey } = companyListingSlice;
